import { css, useTheme } from "@emotion/react";
import { Link } from "react-router";
import { useTitle } from "../hooks/useTitle";

export const EmptyCollectionPage = () => {
  const theme = useTheme();
  useTitle("Empty collection | Compass");

  return (
    <div
      css={css`
        align-items: center;
        display: flex;
        flex-direction: column;
        gap: 48px;
        height: 100%;
        justify-content: center;
      `}
    >
      <div
        css={css`
          align-items: center;
          display: flex;
          flex-direction: column;
        `}
      >
        <h1
          style={{
            ...theme.customTypography.jumbo._1,
            color: theme.colours.primary.dark._20,
          }}
        >
          No bookmarks found in this collection.
        </h1>
      </div>

      <div
        css={css`
          ${theme.colours.primary.dark._20}
          ${theme.customTypography.jumbo._5}
          align-items: center;
          display: flex;
          flex-direction: column;
        `}
      >
        <p>
          <Link to="/bookmarks">Click here</Link> to return to the bookmarks
          page.
        </p>
      </div>
    </div>
  );
};
